module.exports = __webpack_public_path__ + "static/bjorn-erik-erlandsson-kthprofil-fad2b83af944d4c7a22dade1593a20be.pdf";